import React from "react";

const AuctionCardComponent = ({ bank, location, refNo, description, closingDate, emd, estimatedCost, price, daysLeft ,pdfUrl,propertyType}) => {
    return (
        <div className="max-w-[1080px] mx-auto border border-[#F3BD00] rounded-2xl overflow-hidden bg-white">
            <div className="flex py-5">
                <div className="w-[85%]  px-5">
                    <div className="flex justify-between">
                        <h3 className="text-lg font-bold text-gray-800">{bank || "BANK OF BARODA"}</h3>
                        <h3 className="text-lg font-bold text-gray-800">{location || "BHUJ, Gujarat"}</h3>
                        <h3 className="text-lg font-bold text-gray-800">Ref No: {refNo}</h3>
                    </div>

                    <p className="mt-1 text-sm text-gray-600 pr-10 ">
                        {description || " RES LAND AND BUILDINGS SUB PLOT NO 37 TO 39 AND 43 BY 4 R S NO 59 BY 1 ASHAPURA NAGAR VILL- MIRZAPAR TA-BHUJ DISTT-KUTCH ADMEASURING 75.31 SQMTR"}
                    </p>

                        {/* Property Type Display */}
                    <div className="mt-4">
                        <p className="text-sm text-gray-600">
                            <span className="font-bold">Property Type:</span> 
                            <span className="text-blue-700"> {propertyType || "N/A"}</span>
                        </p>
                    </div>

                    <div className="mt-4">
                        <p className="text-sm text-gray-600">
                            <span className="font-bold">Closing Date:</span>
                            <span className="text-red-500"> {closingDate || "2099-12-31"}</span>
                        </p>
                    </div>

                    <div className="mt-4 flex justify-between items-center">
                        <p className="text-sm text-gray-600">
                            <span className="font-bold">EMD:</span> ₹ {emd.toLocaleString() || "NA"} | <span className="font-bold">Estimated Cost:</span>
                            ₹{estimatedCost.toLocaleString() || "NA"}
                        </p>

                    </div>

                </div>
                <div className="w-[15%]  px-2">
                    <p className="text-xl font-bold text-gray-800 text-center">{price || "NA"}</p>
                    <div className="text-xs text-[#787070] font-semibold text-center">
                        {daysLeft || "N/A"} days left
                    </div>
                    <div className="mt-2">
                        <button 
                        className="bg-[#45AD96] text-white w-full py-1 rounded-full hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-offset-2 font-sm"
                        onClick={() => window.open(pdfUrl, "_blank")}
                        >
                            View Detail
                        </button>
                    </div>


                </div>



            </div>
        </div>
    );
};

export default AuctionCardComponent;
